'use client';
import React, { useEffect, useRef } from 'react';

interface AdSlotProps {
  type?: 'horizontal' | 'square' | 'vertical';
  className?: string;
  label?: string;
}

// Fixed heights reserved per ad type — prevents CLS by reserving space before ad loads
const AD_HEIGHTS: Record<string, number> = {
  horizontal: 90,
  square: 250,
  vertical: 600,
};

export default function AdSlot({ type = 'horizontal', className = '' }: AdSlotProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const loaded = useRef(false);
  const reservedHeight = AD_HEIGHTS[type] ?? 90;

  useEffect(() => {
    if (loaded.current || !containerRef.current) return;
    loaded.current = true;

    // Set atOptions on window
    (window as any).atOptions = {
      key: '1a8dad5e58a8f2586f181ab9173300bc',
      format: 'iframe',
      height: 90,
      width: 728,
      params: {},
    };

    // Inject invoke script
    const script = document.createElement('script');
    script.src = 'https://www.highperformanceformat.com/1a8dad5e58a8f2586f181ab9173300bc/invoke.js';
    script.async = true;
    containerRef.current.appendChild(script);
  }, []);

  return (
    <div
      className={`w-full flex flex-col items-center gap-2 overflow-hidden ${className}`}
      role="complementary"
      aria-label="Advertisement"
      // Reserve total vertical space = banner (90px) + effectivecpm slot (90px) + gap (8px)
      style={{ minHeight: reservedHeight + 98 }}
    >
      {/* highperformanceformat ad — fixed 90px height reserved */}
      <div
        ref={containerRef}
        className="w-full flex items-center justify-center"
        style={{ minHeight: 90, width: '100%' }}
      />
      {/* effectivecpmnetwork ad — fixed 90px height reserved */}
      <div
        id="container-365b4498138e56312bfe308206d2c0ff"
        className="w-full flex items-center justify-center"
        style={{ minHeight: 90, width: '100%' }}
      />
    </div>
  );
}
